import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import { jsx as ___EmotionJSX } from "@emotion/core";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React, { Component } from 'react';
import deepEqual from 'react-fast-compare';
import TableSelectableCell from "./TableSelectableCell";
import TableCell from "./TableCell";
import TableRow from "./TableRow";

var TableDataRow =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(TableDataRow, _Component);

  function TableDataRow() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "toggle", function () {
      var toggle = _this.props.toggle;
      toggle && toggle(_this.props.data);
    });

    return _this;
  }

  var _proto = TableDataRow.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return !deepEqual(this.props, nextProps);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        checked = _this$props.checked,
        columns = _this$props.columns,
        data = _this$props.data,
        messages = _this$props.messages,
        rowIndex = _this$props.rowIndex,
        toggle = _this$props.toggle,
        restProps = _objectWithoutPropertiesLoose(_this$props, ["checked", "columns", "data", "messages", "rowIndex", "toggle"]);

    var selectable = Boolean(toggle);
    var cells = columns.map(function (_ref) {
      var render = _ref.cell,
          key = _ref.key,
          restColumn = _objectWithoutPropertiesLoose(_ref, ["cell", "key"]);

      var ignoreContent = restColumn.content,
          ignoreLabel = restColumn.label,
          column = _objectWithoutPropertiesLoose(restColumn, ["content", "label"]);

      var cellProps = _objectSpread({
        children: data[key],
        columnKey: key,
        rowIndex: rowIndex,
        key: key,
        render: render
      }, column);

      return ___EmotionJSX(TableCell, _extends({
        key: key
      }, cellProps));
    });

    if (selectable) {
      cells.unshift(___EmotionJSX(TableSelectableCell, {
        checked: checked,
        disabled: data.disabled,
        key: "selectable",
        label: checked ? messages.deselectRow : messages.selectRow,
        onChange: this.toggle
      }));
    }

    var rowProps = _objectSpread({
      children: cells,
      isSelected: checked,
      isSelectable: selectable
    }, data.row ? {
      render: data.row
    } : undefined, {
      rowIndex: rowIndex
    }, restProps);

    return ___EmotionJSX(TableRow, rowProps);
  };

  return TableDataRow;
}(Component);

_defineProperty(TableDataRow, "displayName", 'TableDataRow');

export { TableDataRow as default };